import axios from 'axios';

const LineItemService = {
  async getLineItem(id) {
    const response = await axios.get(`/line_item/${id}`);

    return response.data;
  },

  async createLineItem(formValues) {
    const response = await axios.post('/line_item', formValues);

    return response.data;
  },

  async deleteLineItem(id) {
    const response = await axios.delete(`/line_item/${id}`);

    return response.data;
  },

  async updateLineItem(id, formValues) {
    const response = await axios.put(`/line_item/${id}`, formValues);

    return response.data;
  },

  async reversePayment(id) {
    const response = await axios.post(`/line_item/${id}/reverse`);

    return response.data;
  },
};

export default LineItemService;
